import React from "react"
import { BrowserRouter, Route, Switch } from "react-router-dom"
import SubTitleTable from "../InformationTable/SubTitleTable"
import { NavTabsProps } from "./interfaces"
import NavTabsContent from "./NavTabsContent"
import { concatClassNames } from "helpers/jsxHelpers"
import "./navTabs.scss"

const NavTabs: React.FC<NavTabsProps> = ({
	subtitleContent,
	title,
	tabs,
	className,
}) => {
	const containerStyles = concatClassNames(["navtabs-container", className])
	const headerStyles = concatClassNames(["navtabs-container-header", className])
	const titleStyles = concatClassNames([
		"navbar-container-title font-24 bold",
		className,
	])

	return (
		<div>
			<div className={containerStyles}>
				{title ? (
					<div className={headerStyles}>
						<div className={titleStyles}>{title}</div>
					</div>
				) : (
					<></>
				)}
				{subtitleContent ? <SubTitleTable content={subtitleContent} /> : <></>}
				<BrowserRouter>
					<Switch>
						<Route path="/">
							<NavTabsContent tabs={tabs} className={className} />
						</Route>
					</Switch>
				</BrowserRouter>
			</div>
		</div>
	)
}

export default NavTabs
